import { FC } from 'react';
import styled from 'styled-components';

import HasCard, { HasCardProps } from './HasCard';

export type UpgradeToHightPlanProps = HasCardProps & { hasUserCard?: boolean };

const OR = styled.div`
  font-weight: 500;
  margin-bottom: 10px;
  text-align: center;
`;
const NoCardStartBy = styled.div`
  margin-top: 5px;
`;
const Wrapper = styled.div`
  margin-top: 15px;
`;
const PriceWrapper = styled.span`
  color: #cc8b00;
  font-weight: bold;
`;

export const Price: FC = () => <PriceWrapper>$89</PriceWrapper>;

const NoCard = () => (
  <div>
    <span>
      Upgrade to Business plan for one time fee of <Price />. Limited time offer!
    </span>
    <br />
    <NoCardStartBy>Start by adding your credit card first.</NoCardStartBy>
  </div>
);

const UpgradeToHightPlan: FC<UpgradeToHightPlanProps> = ({ hasUserCard, onConfirm }) => (
  <Wrapper>
    <OR>OR</OR>
    {hasUserCard ? <HasCard onConfirm={onConfirm} /> : <NoCard />}
  </Wrapper>
);

export default UpgradeToHightPlan;
